import { render } from "./dataSearch.vue?vue&type=template&id=45c02460&scoped=true"
import script from "./dataSearch.vue?vue&type=script&lang=js"
export * from "./dataSearch.vue?vue&type=script&lang=js"

import "./dataSearch.vue?vue&type=style&index=0&id=45c02460&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c02460"]])

export default __exports__